/* eslint no-restricted-globals:0 */

'use client'

import { Component, ReactNode } from 'react'

import { tracker } from '_libs/common/tracker'

import TrackingContext from './TrackingContext'

type Props = {
  children?: ReactNode
}

class TrackingProvider extends Component<Props> {
  tracker = tracker

  contextValues = {
    tracker: this.tracker,
  }

  render() {
    return (
      <TrackingContext.Provider value={this.contextValues}>
        {this.props.children}
      </TrackingContext.Provider>
    )
  }
}

export default TrackingProvider
